module.exports = __webpack_public_path__ + "img/chart.9297baa3.svg";